import type { BuildingUsage, BuildingUsageCategory } from "@roofseye/contracts";

export const buildingUsageOptions: Array<{
  value: BuildingUsageCategory;
  label: string;
  color: string;
}> = [
  { value: "industrial", label: "Produttivo / industriale", color: "#aa80e8" },
  { value: "commercial", label: "Commerciale", color: "#e9a268" },
  { value: "agricultural", label: "Agricolo", color: "#b5c968" },
  { value: "apartment", label: "Edifici plurifamiliari", color: "#e394bd" },
  { value: "house", label: "Abitazioni singole", color: "#edcf80" },
  { value: "residential", label: "Residenziale · tipo non disponibile", color: "#cbaebc" },
  { value: "public", label: "Pubblico / collettivo", color: "#70cbd0" },
  { value: "other", label: "Altro", color: "#b3bdc9" },
  { value: "unknown", label: "Uso non disponibile", color: "#c9c9c9" }
];

export function parseUsageCategories(value: unknown): BuildingUsageCategory[] {
  const values = typeof value === "string" ? value.split(",") : Array.isArray(value) ? value : [];
  return buildingUsageOptions
    .filter((option) => values.includes(option.value))
    .map((option) => option.value);
}

export function usageCategoryLabel(value: BuildingUsageCategory = "unknown"): string {
  return (
    buildingUsageOptions.find((option) => option.value === value)?.label ?? "Uso non disponibile"
  );
}

export function usageSourceLabel(usage?: BuildingUsage): string {
  if (!usage || usage.nature === "unavailable") return "Da approfondire";
  return `${usage.nature === "estimated" ? "Uso stimato" : "Uso da fonte"}${usage.source ? ` · ${usage.source}` : ""}${usage.conflicting ? " · Fonti discordanti" : ""}`;
}
